import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Form } from 'reactstrap';
import qs from 'qs';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';

import Serializer from 'helpers/form-serialize';
import { login } from 'redux/auth/actions';
import { selectState } from 'redux/selectors';
import ForgotPasswordButton from './ForgotPasswordButton';

class Login extends Component {
  static propTypes = {
    history: PropTypes.shape({}).isRequired,
    tokenInfoRequesting: PropTypes.bool.isRequired,
    formatMessage: PropTypes.func.isRequired,
    login: PropTypes.func.isRequired,
    email: PropTypes.string.isRequired,
  };
  state = {
    showPassword: false,
    email: '',
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.email!==this.props.email){
      this.setState({email: nextProps.email });
    }
  }
  onChangeValue = (event) => this.setState({email: event.target.value});

  toggleVisibility = () => this.setState(prevState => ({ showPassword: !prevState.showPassword }))
  render() {
    const { formatMessage, history, login, tokenInfoRequesting } = this.props;
    const { showPassword, email } = this.state;
    return (
      <Form
        className="login-form h-100"
        onSubmit={(e) => {
          e.preventDefault();
          const loginData = Serializer.serialize(e.target, { hash: true });
          loginData.email = loginData.email.trim();
          login({
            ...loginData,
            onSuccess: () => {
              const { redirect_url: redirectUrl } = qs.parse(history.location.search.slice(1));
              if (redirectUrl) {
                history.push(decodeURI(redirectUrl));
              }
              // if (process.env.NODE_ENV === 'development') {
              //   window.location.reload();
              // }
            },
          });
        }}
        autoComplete="none"
      >
        <div className="input-group-wrapper">
          <div className="input-group bottom-gap">
            <TextField
              autoComplete="none"
              className="input"
              id="username"
              name="email"
              value = {email}
              onChange={this.onChangeValue}
              placeholder={formatMessage('Email')}
              required
              inputProps={{
                autoCapitalize: "none",
              }}
            />
          </div>
          <div className="input-group">
            <TextField
              className="input"
              id="login_password"
              name="password"
              placeholder={formatMessage('Password')}
              required
              type={showPassword ? 'text' : 'password'}
              autoComplete="none"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton style={{ outline: 'none' }} onClick={this.toggleVisibility}>
                      {showPassword ? <Visibility /> : <VisibilityOff /> }
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </div>
          {/* <div className='message-fields'>*Email and Password are case sensitive</div> */}
        </div>
        <div className="action-group d-flex justify-content-between">
          <Button
            disabled={tokenInfoRequesting}
            type="submit"
            style={{
              paddingLeft: 20,
              paddingRight: 20,
              backgroundColor: '#4CAF50',
              color: 'white',
            }}
          >
            {formatMessage('Login')}
          </Button>
          <ForgotPasswordButton
            disabled={tokenInfoRequesting}
            formatMessage={formatMessage}
          />
        </div>
      </Form>
    );
  }
}

/* istanbul ignore next */
const mapStateToProps = state => ({
  ...selectState('auth', 'tokenInfo')(state, 'tokenInfo'),
});

/* istanbul ignore next */
const mapDispatchToProps = dispatch => ({
  login: payload => dispatch(login(payload)),
});

const wrappedLogin = connect(mapStateToProps, mapDispatchToProps)(Login);
wrappedLogin.displayName = 'Login';

export default wrappedLogin;
